import { render } from "./DialogCookie.vue?vue&type=template&id=29c0e86d&scoped=true"
const script = {}

import "./DialogCookie.vue?vue&type=style&index=0&id=29c0e86d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c0e86d"]])

export default __exports__